package com.iregained.site.components.widgets

import androidx.compose.runtime.*
import com.iregained.site.theme.toSitePalette
import com.iregained.site.theme.unextractable
import com.iregained.site.utils.Res
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.w3c.dom.SMOOTH
import org.w3c.dom.ScrollBehavior
import org.w3c.dom.ScrollToOptions

@Composable
fun BackToTopButton() {
    var isVisible by remember { mutableStateOf(false) }
    val palette = ColorMode.current.toSitePalette()

    LaunchedEffect(Unit) {
        window.addEventListener("scroll", {
            isVisible = window.scrollY > 500.0
        })
    }

    // UNIQUE ANIMATION: Smooth Pop & Float
    // Always in the DOM, but animated in/out and pointer-events disabled when hidden
    Box(
        modifier = Modifier.position(Position.Fixed).bottom(10.px).right(10.px).size(50.px)
        .backgroundColor(palette.brand.primary).borderRadius(50.percent).zIndex(9999)
        .boxShadow(0.px, 10.px, 20.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.2f))
        .opacity(if (isVisible) 1 else 0).translateY(if (isVisible) 0.px else 20.px)
        .styleModifier { if (!isVisible) property("pointer-events", "none") }.transition(
            Transition.of("opacity", 0.4.s, TransitionTimingFunction.EaseOut),
            Transition.of("transform", 0.4.s, TransitionTimingFunction.EaseOut)
        ).cursor(Cursor.Pointer).onClick {
            window.scrollTo(ScrollToOptions(top = 0.0, behavior = ScrollBehavior.SMOOTH))
        }, contentAlignment = Alignment.Center
    ) {
        Image(
            src = Res.Images.Common.BACK_TO_TOP, modifier = Modifier.unextractable().size(36.px)
        )
    }
}